import { Directive, Input, HostBinding, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FullScreenElementService } from './full-screen-element.service';

@Directive({
  selector: '[azavista3FullScreenElement]',
  standalone: true,
})
export class FullScreenElementDirective implements OnDestroy {
    _fullScreenMode = false;
    public get fullScreenMode() {
        return this._fullScreenMode;
    }
    /**
     * if receives `true` value, the current element will automatically become the only displayed element in the page
     *
     * @param value if it receive null/undefined value, then it will be skipped
     */
    @Input('azavista3FullScreenElement')
    public set fullScreenMode(value: boolean) {
        if (value == null) {
            return;
        }
        this._fullScreenMode = value;
        this.fullScreenSvc.toggleFullScreenMode(value);
        this.fullScreenModeChanges.emit(value);
    }

    @HostBinding('class.azavista3FullScreenElement')
    get fullScreenModeClass() {
        return this.fullScreenMode;
    }

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output('azavista3FullScreenElementChanges')
    fullScreenModeChanges = new EventEmitter<boolean>();


    constructor(
        private fullScreenSvc: FullScreenElementService,
    ) {}

    ngOnDestroy(): void {
        if (this.fullScreenMode) {
            this.fullScreenMode = false;
        }
    }
}
